import React from 'react';

const SubFieldAttrs = ({ goToExamples }) => {
  return (
    <div>
      <h4>
        Subfields [attribute][type][value]
      </h4>
      <p>
        Additional characteristics of a brick (See section: <a onClick={() => goToExamples()}>Examples of product codes
        in XML</a>)
      </p>
      <p>
        Subfield [type] starts with 2 and is followed by 7 digits.
        <br/>
        Subfield [value] starts with 3 and is followed by 7 digits.
      </p>
      <p>
        <strong>OPTIONAL</strong><br/>
        <strong>REPEATABLE</strong>
      </p>
      <div>
        Example:
      </div>
      <pre>
          <code className="language-xml">
            {`<recall lang="en" xmlns="urn:recall-schema">
  <product_code>
    <publication>2011-12-01</publication>
    <brick>10000917</brick>
    <attribute>
      <type>20000045</type>
      <value>30006665</value>
      <value>30006666</value>
      <value>30006667</value>
    </attribute>
  </product_code>
  ...
</recall>
`}
          </code>
        </pre>
    </div>
  );
};

export default SubFieldAttrs;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/product-codes/sub-field-attrs.js